module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_17.c53ca6bf.png";